<script setup lang="ts">
import { onBeforeMount, PropType, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import ModuleLoading from "@/ui/components/loading/moduleLoading.vue";
import { toastApiResult } from "@/toaster";
import { loadingWrapper } from "@/api/helpers/loadingWrapper";
import NotificationSettingsManager from "@/modules/users/components/NotificationSettingsManager.vue";

const props = defineProps({
	user: {
		type: Object as PropType<App.Data.UserDO>,
		require: true,
	},
});

// Emit is not used in this component but required through the tabs-router-view setup.
const emit = defineEmits(["update-user"]);

const availableNotificationTypes: Ref<App.Data.NotificationTypeDO[]> = ref();

const loadAvailableNotifications = async () => {
	const response = await loadingWrapper(
		useApiClient("notifications").getAvailableNotificationTypes()
	);

	if (response.isOk()) {
		availableNotificationTypes.value = response.value;
	}
};

onBeforeMount(() => {
	loadAvailableNotifications();
});

const updateNotificationSettings = () => {
	return async (updateNotificationDTO: App.Data.UpdateNotificationDTO) => {
		const response = await toastApiResult(
			useApiClient("users").updateNotificationTypeChannel(
				props.user?.uuid,
				updateNotificationDTO
			)
		);
	};
};
</script>

<template>
	<module-loading>
		<notification-settings-manager
			:async-update-function="updateNotificationSettings()"
			:configured-notification-types="user.notificationTypes"
			:available-notification-types="availableNotificationTypes"
		>
		</notification-settings-manager>
	</module-loading>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
